export const brand = {
  wordmark:
    'https://cdn.magicpatterns.com/uploads/ppY4tPBdwodPDmeuodkwiQ/LetLois_Logo_Wide_Lapels_Blue_Transparent_(2).png',
  mark:
    'https://cdn.magicpatterns.com/uploads/7VyHUCEMtuHDrcDWUNdw5g/LetLois_Logo_Woman_Wide_Lapels_Blue_Transparent.png',
  onboardingUrl: 'onboarding.letlois.com',
  supportEmail: 'info@letlois.com',
  supportPhone: '+16024618204',
  supportPhoneDisplay: '(602) 461-8204',
}
